export const VEHICLES_ON_SITE_REPORT = 'VehiclesOnSite';
export const VEHICLES_ON_SITE_REPORT_TITLE = 'Vehicles on Site';
export const VEHICLES_ON_SITE_REPORT_INFO = 'Displays the Vehicles On Site report for the date range provided';
export const VEHICLES_ON_SITE_REPORT_SHEET_TITLE = 'Vehicles on site (v01)';

export const columns = [
  { name: 'repairerName', title: 'Repairer Name', width: '150' },
  { name: 'schemeCode', title: 'Scheme Code' },
  { name: 'regMark', title: 'Vehicle Reg.' },
  { name: 'claimID', title: 'Claim ID' },
  { name: 'claimReference', title: 'Claim Ref.', width: '150' },
  { name: 'localStatus', title: 'Local Status' },
  { name: 'manufacturer', title: 'Manufacturer' },
  { name: 'model', title: 'Model' },
  { name: 'dtgCreated', title: 'Date Created', type: 'date' },
  { name: 'dtgBookedIn', title: 'Date Booked In', type: 'date' },
  { name: 'dtgOnSite', title: 'On Site Date', type: 'date' },
  { name: 'courtesyMake', title: 'Courtesy Make' },
  { name: 'replacementReg', title: 'Replacement Reg.' },
];

// TODO: remove after testing 
export const mockedReportData = [
  {
    repairerName: "Pinetree EVAL Lee",
    schemeCode: "AVANT_ALLI",
    regMark: "ACCO1",
    claimID: 7,
    localStatus: "PARTS ORDER",
    manufacturer: "Unknown",
    model: "",
    dtgCreated: "2026-02-23T10:54:59",
    dtgBookedIn: "2026-02-23T11:00:00",
    dtgOnSite: "2026-02-23T10:56:45",
    courtesyMake: "",
    replacementReg: null,
    claimReference: "ABCD123EFG"
  },
  {
    repairerName: "FMG Repair Services (Barnstaple)",
    schemeCode: "ADMIRAL",
    regMark: "PSL73Y",
    claimID: 2772,
    localStatus: "CANCELLED",
    manufacturer: "Peugeot",
    model: "305",
    dtgCreated: "2026-02-02T15:05:20",
    dtgBookedIn: "2026-02-05T00:00:00",
    dtgOnSite: "2026-02-05T12:50:58",
    courtesyMake: "",
    replacementReg: null,
    claimReference: "AdmiralTestFMGA"
  },
  {
    repairerName: "BMS DXTEST TEST DLG A (REST)",
    schemeCode: "DIRECT",
    regMark: "AD16CDE",
    claimID: 3142948,
    localStatus: "FINISHED",
    manufacturer: "Ford",
    model: "Endeavour",
    dtgCreated: "2026-02-07T11:05:24",
    dtgBookedIn: "2026-02-08T11:05:24",
    dtgOnSite: "2026-02-09T11:05:24",
    courtesyMake: "HONDA",
    replacementReg: "CC123AC",
    claimReference: "CLM-2026-03022606"
  },
  {
    repairerName: "Pinetree Repairer1",
    schemeCode: "DLGDLINE",
    regMark: "TESTAT34",
    claimID: 2213,
    localStatus: "ON SITE",
    manufacturer: "Alfa Romeo",
    model: "",
    dtgCreated: "2026-02-27T15:38:15",
    dtgBookedIn: "2026-02-27T09:00:00",
    dtgOnSite: "2026-02-27T15:38:35",
    courtesyMake: "",
    replacementReg: null,
    claimReference: ""
  },
  {
    repairerName: "FMG Repair Services (Barnstaple)",
    schemeCode: "ADMIRAL",
    regMark: "FD64HFV",
    claimID: 2782,
    localStatus: "FINISHED",
    manufacturer: "Acura*",
    model: "TEST",
    dtgCreated: "2026-02-06T14:35:09",
    dtgBookedIn: "2026-02-06T00:00:00",
    dtgOnSite: "2026-02-06T14:54:03",
    courtesyMake: "",
    replacementReg: null,
    claimReference: "2000914969"
  },
  {
    repairerName: "Fix Auto Daventry",
    schemeCode: "FIXADM",
    regMark: "AVM1",
    claimID: 2000920644,
    localStatus: "FINISHED",
    manufacturer: "LAMBORGHINI*",
    model: "URUS",
    dtgCreated: "2026-02-23T11:30:08",
    dtgBookedIn: null,
    dtgOnSite: "2026-02-23T20:45:05",
    courtesyMake: "",
    replacementReg: null,
    claimReference: "2000920644"
  },
]